module.exports = __webpack_public_path__ + "static/20230619_180-c74bf00709d59e8fa16b4964135761c9.jpg";